module.exports = __webpack_public_path__ + "695a060177aa3f6d1f9b669148f77d6c.mp3";